import { ServicesHome } from '@/components/services/ServicesHome'

export default function ServicesScreen() {
  return <ServicesHome />
}
